import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import { IC_STAR_FILLED } from '../../Assets/images';
import { StarRatingNumberOnlyStyled } from './StarRatingNumberOnlyStyled';

const StarRatingNumberOnly = ({ ratings, className, iconWidth, iconHeight, imageSrc, isProductCard }) => {
  return (
    <StarRatingNumberOnlyStyled className={className} isProductCard={isProductCard}>
      <div className="ic">
        <Image src={getImageUrlWithSize(imageSrc?.src, 14, 14) || IC_STAR_FILLED} width={iconWidth || '14px'} height={iconHeight || '14px'} alt="Star" />
      </div>
      <div className="rating">{ratings}</div>
    </StarRatingNumberOnlyStyled>
  );
};

StarRatingNumberOnly.propTypes = {
  ratings: PropTypes.number,
  className: PropTypes.string,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  imageSrc: PropTypes.any,
  isProductCard: PropTypes.bool,
};

StarRatingNumberOnly.defaultProps = {
  isProductCard: false,
};

export default StarRatingNumberOnly;
